import Cookies from 'js-cookie'
const state = {
  //0.默认图片地址
  defaultPicUrl: 'https://hxtspt.com/ftp/',
  // defaultLocalUrl: 'http://192.168.200.72:8080/computing',
  defaultLocalUrl: 'https://hxtspt.com/computing',
  systemcode: '1019', //系统编号
  projectno: '00', //项目编号
  defaultCountdownTime: 300, //默认倒计时300s

  defaultClient:"PC",//默认客户端类型
  defaultClientSys:"天算平台",//默认系统名称
  defaultUserType:"1",//默认用户类型
  defaultCompanyid:"CQJXKJ",//默认公司id
  officeid:"HYZX001",//默认部门id
  //1.账号状态信息 ------------------------
  userInfoChange: false, //用户信息更新标识
  user: Cookies.get('user') == undefined ? '' : Cookies.get('user'), //昵称
  userId: Cookies.get('userId') == undefined ? '' : Cookies.get('userId'), //账号id
  token: Cookies.get('token') == undefined ? '' : Cookies.get('token'), //token
  userImage: Cookies.get('userImage') == undefined ? '' : Cookies.get('userImage'), //用户头像
  expirationTime: Cookies.get('expirationTime'), //token到期时间 毫秒的时间戳
  islogined: Cookies.get('islogined') == null || Cookies.get('islogined') == undefined ? false : Cookies.get(
    'islogined'), //登录状态:已登录true  未登录false
  autoLogin: Cookies.get('autoLogin') == null || Cookies.get('autoLogin') == undefined ? false : Cookies.get(
    'autoLogin'), //是否有效期内登录
  //2.默认分页参数
  defaultPageNo: 1, //默认页码
  defaultPageSize: 10 //默认每页数据数量

}
export default state;



// WEBPACK FOOTER //
// ./src/store/state.js